import { TGiftTypes } from '../../generated/graphql';
import { isDependant } from '../recipients/shared';
type TGiftRecipientData = {
  recipient?: object | null;
};

type TGiftEventData = {
  type: TGiftTypes;
  customType?: string | null;
};

export const getGiftRecipientType = (gift: TGiftRecipientData) => {
  if (!gift.recipient) return '';

  if (isDependant(gift.recipient))
    switch (gift.recipient.type) {
      case 'child':
        return 'Child';
      case 'significantOther':
        return 'Signficant Other';
      case 'pet':
        return gift.recipient.petType || 'Pet';
    }

  return 'Employee';
};

export const getGiftEventType = (gift: TGiftEventData) => {
  switch (gift.type) {
    case TGiftTypes.Birthday:
      return 'Birthday';
    case TGiftTypes.WorkAnniversary:
      return 'Work Anniversary';
    case TGiftTypes.NewHire:
      return 'New Hire';
    case TGiftTypes.BabyGift:
      return 'Baby Gift';
    case TGiftTypes.Bereavement:
      return 'Bereavement';
    case TGiftTypes.Wedding:
      return 'Wedding/Engagement';
    case TGiftTypes.ReplacementWorkAnniversary:
      return 'Replacement Work Anniversary';
    case TGiftTypes.ReplacementEmployeeBirthday:
      return 'Replacement Employee Birthday';
    case TGiftTypes.CarePackage:
      return 'Care Package';
    case TGiftTypes.CustomBricks:
      return gift?.customType || 'Custom Bricks';
    case TGiftTypes.Other:
      return gift.customType;
  }
};
